import React from "react";
import {
  Grid,
  Box,
  Typography,
  Autocomplete,
  TextField,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Tooltip,
  IconButton
} from "@mui/material";
import moment from "moment";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import { esComprobanteBanco } from "../functions";

// Deben coincidir con el LPAD(pv,4)-LPAD(nro,8) del auto-registro del backend: nro_comprobante
// es el unico campo confiable para deduplicar contra comprobantes ya cargados (nro_cae esta vacio
// en toda la base), asi que si los largos divergen la misma factura genera duplicados.
const LARGO_PTO_VENTA = 4;
const LARGO_NRO_COMPROBANTE = 8;

function CabeceraComprobanteArca({
  datosCabecera,
  almacenarCabecera,
  tiposComprobantes,
  comprobanteSelected,
  setcomprobanteSelected,
  bancos,
  proveedores,
  proveedorSelected,
  inputValue,
  setInputValue,
  sucursales,
  timeoutRef,
  condicionesPago,
  tipoMoneda,
  getProveedores,
  setProveedores,
  imputaciones,
  style,
  handleOnChangeProvSel,
  totalMuestro,
  handleOnChangeTotal,
  loading,
  handleAddProveedor,
  handleOnBlurTotal,
  empresas,
  empresaFija,
  bloqueoArca,
  bloqueoProveedorArca
  // handleOnBlurMontoMaximo
  // total,
  // handleOnChangeFechaComprobante,
  // formatNumber,
  // setTotal,
  // handleCloseAddProveedor
}) {
  const esBanco = esComprobanteBanco(comprobanteSelected);
  const fechaHoy = moment().format("YYYY-MM-DD");

  return (
    <div>
      <Grid container spacing={1.5}>
        <Grid item xs={11.5} sm={5.5} md={2.5}>
          <Autocomplete
            required
            disabled={bloqueoProveedorArca}
            sx={{ backgroundColor: "white" }}
            disableClearable
            placeholder="Nombre, CUIT o Sisven ID"
            options={proveedores}
            value={proveedorSelected}
            inputValue={inputValue}
            loading={loading}
            loadingText={"Cargando..."}
            onChange={(e, value) => {
              handleOnChangeProvSel(e, value);
            }}
            noOptionsText={"No existe proveedor"}
            onInputChange={(e, value, reason) => {
              setInputValue(value);

              if (timeoutRef.current) {
                clearTimeout(timeoutRef.current);
                timeoutRef.current = null;
              }

              if (value?.length >= 2) {
                timeoutRef.current = setTimeout(() => {
                  getProveedores(value);
                  timeoutRef.current = null;
                }, 300);
              } else {
                setProveedores([]);
              }
            }}
            getOptionLabel={(option) =>
              `${option?.denominacion} (${option?.cuit})`
            }
            renderOption={(props, option) => (
              <Box
                component="li"
                key={option.denominacion}
                sx={{ "& > img": { mr: 2, flexShrink: 0 } }}
                {...props}
              >
                {`${option?.denominacion} (${option?.cuit}) `}
              </Box>
            )}
            renderInput={(params) => (
              <TextField
                focused
                fullWidth
                placeholder="Tipee para buscar proveedores.."
                {...params}
                variant="outlined"
                size="small"
                label="Proveedores"
                required={proveedorSelected === null}
              />
            )}
          />
        </Grid>
        <Grid
          xs={0.5}
          sm={0.5}
          md={0.5}
          display="flex"
          alignItems="flex-end"
          justifyContent="flex-end"
        >
          <Tooltip title="Nuevo proveedor">
            <span>
              <IconButton
                color="primary"
                onClick={handleAddProveedor}
                size="medium"
                disabled={bloqueoProveedorArca}
              >
                <AddCircleOutlineIcon />
              </IconButton>
            </span>
          </Tooltip>
        </Grid>

        <Grid
          container
          pl={1}
          xs={12}
          sm={esBanco ? 6 : 6}
          md={esBanco ? 4 : 3}
          lg={esBanco ? 4 : 3}
          direction="row"
          justifyContent="space-between"
          alignItems="flex-end"
        >
          {esBanco ? (
            <Tooltip title="Banco del resumen bancario.">
              <Grid item xs={8} sm={8} md={8} lg={8} mt={1}>
                <FormControl style={style} focused required fullWidth size="small">
                  <InputLabel>Banco</InputLabel>
                  <Select
                    name="id_banco"
                    value={datosCabecera.id_banco ?? ""}
                    label="Banco"
                    onChange={almacenarCabecera}
                  >
                    {bancos?.map((banco) => (
                      <MenuItem key={banco.id} value={banco.id}>
                        {banco.nombre}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>
            </Tooltip>
          ) : (
            <Tooltip title="Punto de Venta del comprobante cargado.">
              <Grid item xs={3.3} sm={3.3} md={3.3} lg={3.3} mt={1}>
                <TextField
                  onChange={almacenarCabecera}
                  fullWidth
                  variant="outlined"
                  size="small"
                  defaultValue=""
                  type="text"
                  disabled={bloqueoArca}
                  inputProps={{ maxLength: LARGO_PTO_VENTA }}
                  style={style}
                  focused
                  required
                  value={datosCabecera.comprobante_pv}
                  name="comprobante_pv"
                  label="Pto Venta"
                  onKeyPress={(event) => {
                    if (!/[0-9]/.test(event.key)) {
                      event.preventDefault();
                    }
                  }}
                  onBlur={(event) => {
                    const valor = event.target.value;
                    if (!valor) return;
                    almacenarCabecera({
                      target: {
                        name: "comprobante_pv",
                        value: valor.padStart(LARGO_PTO_VENTA, "0"),
                      },
                    });
                  }}
                  sx={{
                    "& .MuiInputBase-input": {
                      textAlign: "right",
                    },
                  }}
                />
              </Grid>
            </Tooltip>
          )}
          <Typography
            variant="body1"
            sx={{
              fontWeight: "bold",
              display: "flex",
              alignItems: "center",
              height: "65%",
            }}
          >
            -
          </Typography>

          <Tooltip title="N° del comprobante cargado.">
            <Grid item xs={esBanco ? 3 : 8.3} sm={esBanco ? 3 : 8.3} md={esBanco ? 3 : 8.3} lg={esBanco ? 3 : 8.3}>
              <TextField
                fullWidth
                onChange={almacenarCabecera}
                value={datosCabecera.comprobante_nro}
                variant="outlined"
                size="small"
                defaultValue=""
                type="text"
                disabled={bloqueoArca}
                inputProps={{ maxLength: LARGO_NRO_COMPROBANTE }}
                style={style}
                focused
                required
                id="nro_comprobante"
                name="comprobante_nro"
                label="Nro Comprobante"
                onKeyPress={(event) => {
                  if (!/[0-9]/.test(event.key)) {
                    event.preventDefault();
                  }
                }}
                onBlur={(event) => {
                  const valor = event.target.value;
                  if (!valor) return;
                  almacenarCabecera({
                    target: {
                      name: "comprobante_nro",
                      value: valor.padStart(LARGO_NRO_COMPROBANTE, "0"),
                    },
                  });
                }}
              />
            </Grid>
          </Tooltip>
        </Grid>

        <Grid item xs={12} sm={6} md={3}>
          <FormControl style={style} focused required>
            <InputLabel>Condicion de compra</InputLabel>
            <Select
              size="small"
              name="id_condicionpago"
              value={datosCabecera.id_condicionpago}
              label="Condicion de compra"
              onChange={almacenarCabecera}
            >
              {condicionesPago?.map((elemento) => (
                <MenuItem key={elemento.id} value={elemento.id}>
                  {elemento.condicion}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid>
        {/* <Grid item xs={12} sm={6} md={3}>
          <FormControl style={style} focused required>
            <InputLabel>Imputado A</InputLabel>
            <Select
              size="small"
              name="id_imputacion"
              value={datosCabecera.id_imputacion}
              label="Imputado a "
              onChange={almacenarCabecera}
            >
              {imputaciones
                ? imputaciones.map((elemento) => (
                  <MenuItem
                    key={elemento.idimputacion}
                    value={elemento.idimputacion}
                  >
                    {elemento.descripcion}
                  </MenuItem>
                ))
                : null}
            </Select>
          </FormControl>
        </Grid> */}
        <Grid item xs={12} sm={6} md={3}>
          <FormControl style={style} focused required>
            <InputLabel>Empresa</InputLabel>
            {empresaFija ? (
              <Select
                size="small"
                name="id_empresa"
                value={empresaFija.id}
                label="Empresa "
                disabled
              >
                <MenuItem value={empresaFija.id}>{empresaFija.nombre}</MenuItem>
              </Select>
            ) : (
              <Select
                size="small"
                name="id_empresa"
                value={datosCabecera.id_empresa}
                label="Empresa "
                onChange={almacenarCabecera}
              >
                <MenuItem key={2} value={2}>
                  Italgas
                </MenuItem>
                <MenuItem key={4} value={4}>
                  Natural Gas
                </MenuItem>
                <MenuItem key={5} value={5}>
                  Metalgar
                </MenuItem>
              </Select>
            )}
          </FormControl>
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <FormControl style={style} focused required>
            <InputLabel>Sucursal</InputLabel>
            <Select
              size="small"
              name="id_sucursal"
              value={datosCabecera.id_sucursal}
              label="Sucursal "
              onChange={almacenarCabecera}
            >
              {sucursales
                ? sucursales.map((elemento) => (
                  <MenuItem key={elemento.id} value={elemento.id}>
                    {elemento.nombre}
                  </MenuItem>
                ))
                : null}
            </Select>
          </FormControl>
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <Autocomplete
            required
            disabled={bloqueoArca && !!comprobanteSelected}
            sx={{ backgroundColor: "white" }}
            disableClearable
            placeholder="Tipo Comprobante"
            options={tiposComprobantes}
            value={comprobanteSelected || null}
            isOptionEqualToValue={(option, value) =>
              option?.id_tipo_comprobante === value?.id_tipo_comprobante
            }
            onChange={(e, value) => {
              setcomprobanteSelected(value);
            }}
            noOptionsText="Tipee para buscar comprobante..."
            getOptionLabel={(option) =>
              `${option?.descripcion} (${option?.id_tipo_comprobante})`
            }
            renderOption={(props, option) => (
              <Box
                component="li"
                key={option.id_tipo_comprobante}
                sx={{ "& > img": { mr: 2, flexShrink: 0 } }}
                {...props}
              >
                {option?.descripcion} ({option?.id_tipo_comprobante})
              </Box>
            )}
            renderInput={(params) => (
              <TextField
                focused
                fullWidth
                placeholder="Tipee para buscar tipo de comprobante.."
                {...params}
                variant="outlined"
                size="small"
                label="Tipo Comprobante"
              />
            )}
          />
        </Grid>

        {esBanco && (
          <Grid item xs={12} sm={6} md={3}>
            <TextField
              onChange={almacenarCabecera}
              fullWidth
              variant="outlined"
              size="small"
              style={style}
              focused
              required
              value={datosCabecera.concepto ?? ""}
              name="concepto"
              label="Concepto"
              placeholder=""
            />
          </Grid>
        )}

        {esBanco ? (
          <Grid item xs={12} sm={4} md={2}>
            <TextField
              type="date"
              focused
              fullWidth
              required
              size="small"
              color="primary"
              style={style}
              label="Fecha"
              name="fecha_factura"
              value={fechaHoy}
              onChange={almacenarCabecera}
              disabled
              InputLabelProps={{ shrink: true }}
            />
          </Grid>
        ) : (
          <Grid item xs={12} sm={6} md={3}>
            <TextField
              type="date"
              focused
              fullWidth
              required
              size="small"
              color="primary"
              style={style}
              label="Fecha de comprobante"
              name="fecha_factura"
              value={moment(datosCabecera.fecha_factura).format("YYYY-MM-DD")}
              onChange={almacenarCabecera}
              disabled={bloqueoArca}
              InputLabelProps={{ shrink: true }}
            />
          </Grid>
        )}
        <Grid item xs={12} sm={6} md={3}>
          <TextField

            type="date"
            focused
            fullWidth
            size="small"
            color="primary"
            style={style}
            label="Vencimiento comprobante"
            name="vto_factura"
            value={moment(datosCabecera.vto_factura).format("YYYY-MM-DD")}
            onChange={almacenarCabecera}
            inputProps={{
              min: moment(datosCabecera.fecha_factura).format("YYYY-MM-DD"),
            }}
          />
        </Grid>
        <Grid item xs={12} sm={6} md={4}>
          <TextField
            disabled={!proveedorSelected || bloqueoArca}
            style={style}
            focused
            type="text"
            autoComplete="off"
            fullWidth
            size="small"
            label="Importe total Factura"
            InputLabelProps={{ shrink: true }}
            name="totalMuestro"
            value={totalMuestro}
            onKeyPress={(event) => {
              const { value } = event.target;

              if (!/[\d,]/.test(event.key)) {
                event.preventDefault();
              }

              if (event.key === "," && value.includes(",")) {
                event.preventDefault();
              }
            }} //coma para los decimales
            onChange={handleOnChangeTotal}
          // onBlur={handleOnBlurTotal}
          />
        </Grid>
        <Grid item xs={12} sm={6} md={4}>
          <FormControl style={style} focused required>
            <InputLabel>Moneda</InputLabel>
            <Select
              label="Moneda"
              size="small"
              name="id_tipomoneda"
              disabled={bloqueoArca}
              value={
                datosCabecera.id_tipomoneda ? datosCabecera.id_tipomoneda : " "
              }
              onChange={almacenarCabecera}
            >
              {tipoMoneda
                ? tipoMoneda.map((elemento) => (
                  <MenuItem key={elemento.id} value={elemento.id}>
                    {elemento.valor}
                  </MenuItem>
                ))
                : null}
            </Select>
          </FormControl>
        </Grid>

        <Grid item xs={4}>
          <TextField
            label="Tipo de cambio"
            InputLabelProps={{ shrink: true }}
            disabled={datosCabecera.id_tipomoneda === 83 || bloqueoArca}
            name="tipo_cambio"
            value={datosCabecera.tipo_cambio ?? ""}
            // onBlur={handleOnBlurMontoMaximo}
            // onChange={(e) => {
            //   let value = e.target.value.replace(",", ".");
            //   const regex = /^\d{0,4}(\.\d{0,2})?$/;
            //   console.log("regex",e.target.name);

            //   if (value === "" || regex.test(value)) {
            //     almacenarCabecera({
            //       ...e,
            //       target: {
            //         ...e.target,
            //         value,
            //       },
            //     });
            //   }
            // }}
            onChange={(e) => {
              let value = e.target.value.replace(",", ".");
              const regex = /^\d{0,4}(\.\d{0,2})?$/;

              if (value === "" || regex.test(value)) {
                almacenarCabecera({
                  target: {
                    name: e.target.name,
                    value: value,
                  },
                });
              }
            }}
            onBlur={(e) => {
              let value = e.target.value.replace(",", ".");
              if (value) {
                const formatted = parseFloat(value).toFixed(2);
                almacenarCabecera({
                  ...e,
                  target: {
                    ...e.target,
                    value: formatted,
                  },
                });
              }
            }}
            // onBlur={(e) => {
            //   handleOnBlurMontoMaximo,
            //   let value = e.target.value.replace(",", ".");
            //   if (value) {
            //     const formatted = parseFloat(value).toFixed(2);

            //     almacenarCabecera({
            //       target: {
            //         name: e.target.name,
            //         value: formatted,
            //       },
            //     });
            //   }
            // }}

            onKeyDown={(e) => {
              const { key } = e;
              const value = e.target.value;

              const isNumber = /^[0-9]$/.test(key);
              const isDotOrComma = key === "." || key === ",";
              const isControl = [
                "Backspace",
                "Tab",
                "ArrowLeft",
                "ArrowRight",
                "Delete",
              ].includes(key);

              if (!isNumber && !isDotOrComma && !isControl) {
                e.preventDefault();
              }

              if (
                isDotOrComma &&
                (value.includes(".") || value.includes(","))
              ) {
                e.preventDefault();
              }

              const [intPart] = value.split(/[.,]/);
              if (
                isNumber &&
                intPart.length >= 4 &&
                !value.includes(".") &&
                !value.includes(",")
              ) {
                e.preventDefault();
              }
            }}
            inputMode="decimal"
            type="text"
            fullWidth
            size="small"
            focused
            style={style}
            required={datosCabecera.id_tipomoneda !== 83}
          />
        </Grid>
      </Grid>
    </div>
  );
}

export default CabeceraComprobanteArca;
